import { onboardingShownForScreen, logOnboardingShown } from "../../utils/onboarding";

const screenName = 'onboardingShownPhotos';

const steps = [
    {
        img2: 'https://denticalc.com/assets/img/.png',
        img: '/images/onboarding/onboarding-implant.jpg',
        description: '<span style="font-size: 17px;">Use Photos by DentiCalc to <b>explain problems</b> or treatments effortlessly and swiftly.<br/><br/></span><span style="font-size: 17px;">Tailored to your patients\' needs, they are <b>ideal visual supports</b> to your explanations.</span>',
        buttons: [
            {
                text: "Let's see the images!",
                class: "primary",
                click: (ctx) => {
                    ctx.currentStep++;
                }
            }
        ],
        mounted: () => {
            logOnboardingShown(screenName);
        }
    }
]

export const onboarding = () => {
    return onboardingShownForScreen(screenName) === 0 ? steps : [];
}
